module.exports = __webpack_public_path__ + "img/shipo-login-image.e48e30f2.svg";